module.exports = __webpack_public_path__ + "static/media/0034.28a9e37c.svg";